import Vue from 'vue'
import Router from 'vue-router'

// import Home from '../components/Home'
// import Members from '../components/Members'
// import Publications from '../components/Publications'

import Home from '../components2/Home'
import People from '../components2/People'
import Publications from '../components2/Publications'
import Software from '../components2/Softwares'
import News from '../components2/News'
import Teacher from '../components2/Teacher'
import Links from '../components2/Links'
import Activities from '../components2/Activities'
import JoinUs from '../components2/JoinUs'
import team from '../components2/team.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '/People',
      name: 'People',
      component: People
    },
    {
      path: '/Teacher',
      name: 'Teacher',
      component: Teacher
    },
    {
      path: '/Publications',
      name: 'Publications',
      component: Publications
    },
    {
      path: '/Research',
      name: 'Research',
      component: Software
    },
    {
      path: '/Research',
      name: 'Research',
      component: Software
    },
    {
      path: '/News',
      name: 'News',
      component: News
    },
    {
      path: '/Links',
      name: 'Links',
      component: Links
    },
    {
      path: '/Activities',
      name: 'Activities',
      component: Activities
    },
    {
      path: '/JoinUs',
      name: 'JoinUs',
      component: JoinUs
    },
    {
      path: '/team',
      name: 'team',
      component: team
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js